import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  useColorModeValue
} from "@chakra-ui/react";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContatoType } from "models/contato_type";
import { PessoaType } from "models/person_type";
import { Project, ProjectCategory } from "models/project_type";
import { UsuarioModel } from "models/user_model";
import { MdCurrencyExchange, MdSave } from "react-icons/md";
import FormClient from "views/admin/clients/components/Form";
import useClients from "views/admin/clients/hooks/useClients";
import AdmItemTable from "./AdmItemTable";
import { OSType } from "models/os_type";
import ContasPagarForm from "./ContasPagar";

interface IAdmForm {
  showModal: (show: boolean, item: Project) => void;
  show: boolean;
  accountSelected: Project;
  loading: boolean;
  contatoAgencia: ContatoType;
  contatoCliente: ContatoType;
  users: UsuarioModel[];
  clients: PessoaType[];
  fornecedor: PessoaType[];
  condicaoPagamento: CondicaoPagamento[];
  loadOs: (item: ProjectCategory) => void;
  loadFornecedores: () => void;
  errorTitle: string;
  errorMsg: string;
  error: boolean;
  showError: (title: string, msg: string) => void;
  osList: OSType[];
  setOsList: React.Dispatch<React.SetStateAction<OSType[]>>;
  saveOs: () => Promise<void>
  deleteOs: (id: string) => Promise<void>
  showContaPagarModal: boolean,
  setShowContaPagarModal: (show: boolean) => void;
}
const AdmForm = ({
  show,
  showModal,
  accountSelected,
  loading,
  contatoAgencia,
  contatoCliente,
  users,
  clients,
  fornecedor,
  condicaoPagamento,
  loadOs,
  loadFornecedores,
  error,
  errorMsg,
  errorTitle,
  showError,
  osList,
  setOsList,
  saveOs,
  deleteOs,
  setShowContaPagarModal,
  showContaPagarModal,
}: IAdmForm) => {
  const borderColor = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const {
    enderecoList,
    showFormPessoa,
    adicionarContato,
    adicionarEndereco,
    bairroRef,
    cargoContatoRef,
    cepRef,
    changeFilial,
    changeItemPessoa,
    cidadeRef,
    classificacaoList,
    classificacaoRef,
    client,
    complementoRef,
    contatoList,
    contribuinteRef,
    deleteContato,
    showPessoa,
    idTipoRef,
    documentoRef,
    razaoSocialRef,
    nomeFantasiaRef,
    inscricaoMunicipalRef,
    inscricaoEstadualRef,
    tipoPessoaList,
    ruaRef,
    numeroRef,
    estadoRef,
    principalRef,
    loadCEP,
    viaCepEnd,
    deleteEnd,
    emailContatoRef,
    principalContatoRef,
    nomeContatoRef,
    filial,
    telefoneContatoRef,
    pessoaFilial,
    nomeClinteRef,
    editPessoa,
    saveCliente,
    errorCliente,
    errorMsgCliente,
    errorTitleCliente,
    cancelPessoaRef,
    closeErrorPessoa,
    contaList,
    bancoRef,
    agenciaRef,
    tipoRef,
    numeroContaRef,
    titularRef,
    tipoPessoaRef,
    documentoContaRef,
    descricaoRef,
    obsRef,
    deleteConta,
    adcionarConta,
  } = useClients();
  const editarPessoa = (item: PessoaType) => {
    if (item === undefined || item === null) {
      showError("Erro!", "Selecione o Cliente/Agência para editar seus dados!");
    } else {
      editPessoa(item);
    }
  };

  const savePersonData = async () => {
    await saveCliente();
    await loadFornecedores();
  };
  return (
    <Box>
      <Box>
        <Box
          justifyContent="space-between"
          pt={4}
        >
          <Box
            px="0px"
            mb="16px"
            mt="0px"
            ml={4}
            display="flex"
            flexDirection="row"
          >
            <Stack direction="row" spacing={4}>
              <Button
                leftIcon={<MdSave />}
                colorScheme="brand"
                size={"sm"}
                ml={2}
                variant="solid"
                isLoading={loading}
                onClick={saveOs}
              >
                Salvar
              </Button>
            </Stack>

            <Stack direction="row" spacing={4}>
              <Button
                leftIcon={<MdCurrencyExchange />}
                colorScheme="brand"
                size={"sm"}
                ml={2}
                variant="solid"
                isDisabled={osList.filter((item) => !item.id).length > 0}
                isLoading={loading}
                onClick={() => {
                  if (osList.length <= 0) {
                    return;
                  }

                  setShowContaPagarModal(true)
                }}
              >
                Gerar Contas a Pagar
              </Button>
            </Stack>
          </Box>
        </Box>
        {accountSelected?.ProjetoCategoria?.map((item, index) => (
          <>
            <AdmItemTable
              borderColor={borderColor}
              condicaoPagamento={condicaoPagamento}
              fornecedor={fornecedor}
              index={index}
              item={item}
              project={accountSelected}
              loadOs={loadOs}
              editPessoa={editarPessoa}
              showFormPessoa={showFormPessoa}
              osList={osList}
              setOsList={setOsList}
              deleteOs={deleteOs}
              loading={loading}
              showContaPagarModal={showContaPagarModal}
              setShowContaPagarModal={setShowContaPagarModal}
            />
          </>
        ))}
      </Box>

      <FormClient
        enderecoList={enderecoList}
        accountSelected={client}
        brandStars={brandStars}
        error={error}
        loading={loading}
        save={savePersonData}
        nomeRef={nomeClinteRef}
        show={showPessoa}
        showModal={showFormPessoa}
        textColor={textColor}
        idTipoRef={idTipoRef}
        classificacaoRef={classificacaoRef}
        documentoRef={documentoRef}
        razaoSocialRef={razaoSocialRef}
        nomeFantasiaRef={nomeFantasiaRef}
        inscricaoMunicipalRef={inscricaoMunicipalRef}
        inscricaoEstadualRef={inscricaoEstadualRef}
        contribuinteRef={contribuinteRef}
        classificacaoList={classificacaoList}
        tipoPessoaList={tipoPessoaList}
        bairroRef={bairroRef}
        cepRef={cepRef}
        ruaRef={ruaRef}
        numeroRef={numeroRef}
        complementoRef={complementoRef}
        cidadeRef={cidadeRef}
        estadoRef={estadoRef}
        principalRef={principalRef}
        loadCEP={loadCEP}
        viaCepEnd={viaCepEnd}
        adicionarEnd={adicionarEndereco}
        deleteEnd={deleteEnd}
        contatoList={contatoList}
        deleteContato={deleteContato}
        adicionarContato={adicionarContato}
        cargoContatoRef={cargoContatoRef}
        emailContatoRef={emailContatoRef}
        nomeContatoRef={nomeContatoRef}
        principalContatoRef={principalContatoRef}
        telefoneContatoRef={telefoneContatoRef}
        changeItem={changeItemPessoa}
        filial={filial}
        changeFilial={changeFilial}
        pessoaFilial={pessoaFilial}
        adcionarConta={adcionarConta}
        agenciaRef={agenciaRef}
        bancoRef={bancoRef}
        contaList={contaList}
        deleteConta={deleteConta}
        descricaoRef={descricaoRef}
        documentoContaRef={documentoContaRef}
        numeroContaRef={numeroContaRef}
        obsRef={obsRef}
        tipoPessoaRef={tipoPessoaRef}
        tipoRef={tipoRef}
        titularRef={titularRef}
      />

      <ContasPagarForm
        show={showContaPagarModal}
        showModal={setShowContaPagarModal}
        osList={osList}
        fornecedor={fornecedor}
      />

      <AlertDialog
        isOpen={errorCliente}
        leastDestructiveRef={cancelPessoaRef}
        onClose={closeErrorPessoa}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitleCliente}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsgCliente}</AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelPessoaRef}
                onClick={closeErrorPessoa}
                colorScheme={"blue"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};
export default AdmForm;
